<template>
<div class="recruitPopWrap">
	<div class="recruitPopBox">

		<div class="jobTitleWrap">
			<div class="in">
				<h4 class="title">마케팅 부문</h4>
			</div>
		</div>

		<div class="jobListWrap">
			<ul class="jobList">
				<li class="job1">
					<h5 class="jobName">퍼포먼스광고 기획자</h5>
					<ul class="description">
						<li class="intro">
							<span class="tit">소개</span>
							<span>디지털 퍼포먼스 광고 캠페인을 설계하고, 최고의 성과를 내기 위해 캠페인을 운영합니다.</span>
						</li>
						<li class="position">
							<span class="tit">직무</span>
							<span>디지털 퍼포먼스 마케팅 광고 기획, 전략수립 및 제안서 작성, 캠페인 효율분석 및 운영관리, 보고서 작성</span>
						</li>
						<li class="conditions">
							<span class="tit">우대조건</span>
							<ul>
								<li>온라인/디지털 광고대행사 퍼포먼스 광고 기획 업무 경력</li>
								<li>디지털마케팅 시장 / 퍼포먼스 마케팅에 대한 이해도가 높은분</li>
								<li>WPP(SA, DA)/APP 성과분석 플랫폼 활용이 가능하신분</li>
								<li>창의적이고 긍정적인 사고로 능동적인 커뮤니케이션이 가능하신 분</li>
								<li>강한 책임감으로 담당 업무의 완수가 가능한 분</li>
							</ul>
						</li>
					</ul>
				</li>
				<li class="job2">
					<h5 class="jobName">소셜마케팅/디지털캠페인 기획자</h5>
					<ul class="description">
						<li class="intro">
							<span class="tit">소개</span>
							<span>급변하는 소셜 마케팅, 디지털 환경을 연구하고, 트렌드를 읽고, 타겟을 분석하여 성공적인 소셜 커뮤니케이션을 만들어 갑니다.</span>
						</li>
						<li class="position">
							<span class="tit">직무</span>
							<span>소셜 및 디지털 IMC마케팅 광고 기획, 전략 수립, 캠페인 운영/관리, 리포트</span>
						</li>
						<li class="conditions">
							<span class="tit">우대조건</span>
							<ul>
								<li>디지털 광고 및 마케팅 관련 지식 보유</li>
								<li>SNS (페이스북, 인스타그램, 유튜브 등) 플랫폼 기획 및 운영</li>
								<li>SNS 캠페인/콘텐츠 기획 및 운영 경험</li>
								<li>SNS 채널 기획/운영 PM 경험</li>
								<li>SNS 광고 및 기타 디지털 매체 광고 기획 운영 경험</li>
								<li>MS office(워드, 엑셀, 파워포인트) 능숙하게 활용 가능한 분</li>
								<li>해외 여행에 결격 사유가 없는 분</li>
							</ul>
						</li>
					</ul>
				</li>
			</ul>
		</div>

		<div class="btnPopClose"><a href="#;" @click="$emit('close'), popClose()">닫기</a></div>
		
	</div>
</div>
</template>
<script>
export default {
	created(){
		$('body').addClass('popOpen');
	},
	methods: {
		popClose(){
			$('body').removeClass('popOpen');
		}
	}
}
</script>